
$(document).ready(function() {
    messaging.init();

    $('[data-ask]').click(function() {
        messaging.askContentDialog($(this), $(this).attr("data-title"), null, {
            yesButton: 'Ja, löschen',
            content: $(this).attr('data-content'),
        });
        return false;
    });

    // tests
    // var element = $('<a href=""></a>');
    // messaging.askContentDialog(element, 'Frage?', 'Welche Farbe hat der Himmel?');
    // messaging.showPermanentGlobalMessage("danger", "titel hier", "nachricht ist etwas länger aber sicher nicht allzu lange oder etwas doch?");
    // messaging.showPermanentGlobalMessage("warning", "titel hier", "nachricht ist etwas länger aber sicher nicht allzu lange oder etwas doch?");
    // messaging.showPermanentGlobalMessage("success", "titel hier", "nachricht ist etwas länger aber sicher nicht allzu lange oder etwas doch?");
});

$(document).on('content-ready', function (ev, container) {
    container.find('[data-ask-dialog]').click(function() {
        messaging.askYesNoDialog($(this));
        return false;
    });
});

var messaging = {
    messageContainer: null,

    init: function() {
        messaging.messageContainer = $('#global-messaging .messaging-box');
        $.each(messaging.messageContainer.find('>div'), function() {
            var el = $(this);
            messaging.showPermanentGlobalMessage(el.attr('class'), "", el.html());
        });

    },

    showGlobalMessage: function(type, title, message, hideTimeout) {
        messaging.showPermanentGlobalMessage(type, title, message, hideTimeout);
    },

    showPermanentGlobalMessage: function(type, title, message, hideTimeout, userOptions) {
        hideTimeout = hideTimeout || 20000;
        userOptions = userOptions || {};

        var options = {
            type: type,
            timeOut: hideTimeout,
            progressBar: hideTimeout >= 0,
            toastClass: 'toastr',
            positionClass: 'toast-bottom-center',
        };
        if (userOptions.closeOnHover !== undefined) {
            options.closeOnHover = userOptions.closeOnHover;
            options.closeButton = !userOptions.closeOnHover;
        }

        switch (type) {
            case "warning":
                toastr.warning(message, title, options);
                break;
            case "error":
            case "danger":
                toastr.error(message, title, options);
                break;
            case "success":
                toastr.success(message, title, options);
                break;
            case "info":
                toastr.info(message, title, options);
                break;
        }
    },

    askContentDialog: function(element, title, htmlContent, options) {
        options = options || {};
        var dialog = notification.notifyPopup(title, '<div class="loading">'+(htmlContent || options.content || '')+'</div>', {});

        if (element.attr('data-url') || element.attr('data-ajax')) {
            notification.addButton(dialog, {
                caption: options.yesButton || "Weiter",
                cssClass: "btn btn-success action-enter",
                callback: function(notifyEl, btn) {
                    btn.startProcess();
                    if (options.onYes) {
                        return options.onYes(notifyEl);
                    }
                    if (element.is('[data-url]')) {
                        location.href = element.attr('data-url');
                    }
                    if (element.is('[data-ajax]')) {
                        connection.getJson(element.attr('data-ajax'), {
                            onSuccess: function() {
                                notification.close(dialog);
                            }
                        });
                    }
                }
            });
        }
        notification.addButton(dialog, {
            caption: options.noButton || "Schliessen",
            cssClass: "btn btn-danger",
            callback: function() {
                return true;
            }
        });

        var dialogEl = dialog.find('.message');
        if (element.attr('data-ask') || '' !== '') {
            dialogEl.html(element.attr('data-ask'));
            dialogEl.removeClass('loading');
        }

        if (element.attr('data-content')) {
            connection.getHtmlPart(element.attr('data-content'), {
                onSuccess: function (data) {
                    dialogEl.html(data);
                    var btns = dialogEl.find('.buttons').find('>button, >span, >a');
                    btns.appendTo(dialogEl.parent().find('.ui-dialog-buttonset'));
                    dialogEl.trigger('onLaded');
                    if (options.onLoaded) options.onLoaded(dialogEl);
                },
                onComplete: function () {
                    dialogEl.removeClass('loading');
                }
            });
        }

        return dialog;
    },

    askYesNoDialog: function(targetElement) {
        BootstrapDialog.show({
            type: targetElement.attr('data-type') || BootstrapDialog.TYPE_WARNING,
            title: targetElement.attr('data-title') || targetElement.attr('title'),
            closable: targetElement.attr('data-title') || 'false' === 'true',
            message: function (dialog) {
                return $('<div>' + (targetElement.attr('data-question') || '') + '</div>');
            },
            onshow: function(e, el) {
                if (!targetElement.attr('data-question')) {
                    e.$modalBody.hide();
                }
            },
            buttons: [{
                label: 'Ja',
                cssClass: 'btn-outline-primary',
                hotkey: 13, // Enter.
                action: function (dialog) {
                    targetElement.trigger('answer-yes');
                    if (targetElement.is('[data-redirect]')) {
                        location.href = targetElement.attr('data-redirect');
                        return;
                    }
                    connection.getJson(targetElement.attr('data-ask-dialog'), {
                        onSuccess: function(data) {
                            targetElement.trigger('answer-yes-success');
                            dialog.close();
                        }
                    });
                }
            }, {
                label: 'Nein',
                cssClass: 'btn-outline-dark',
                hotkey: 27, // Esc.
                action: function (dialog) {
                    targetElement.trigger('answer-no');
                    dialog.close();
                }
            }]
        });
    },

    askYesNo: function(title, question, onYes, onNo) {
        BootstrapDialog.show({
            type: BootstrapDialog.TYPE_WARNING,
            title: title,
            closable: false,
            message: function (dialog) {
                return $('<div>'+question+'</div>');
            },
            buttons: [{
                label: 'Ja',
                cssClass: 'btn-outline-primary',
                hotkey: 13, // Enter.
                action: function (dialog) {
                    if (onYes) {
                        var result = onYes(dialog.$modal);
                        if (result !== false) {
                            dialog.close();
                        }
                    } else {
                        dialog.close();
                    }
                }
            }, {
                label: 'Nein',
                cssClass: 'btn-outline-dark',
                hotkey: 27, // Esc.
                action: function (dialog) {
                    if (onNo) onNo();
                    dialog.close();
                }
            }]
        });
    },

};

window.messaging = messaging;
